/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Agensi_P1dInputs */

const en_mk_sol_agensi_p1d = /** @type {(inputs: Mk_Sol_Agensi_P1dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Client decisions scatter across WhatsApp groups. By the third revision nobody can point at what was agreed in the first.`)
};

const id_mk_sol_agensi_p1d = /** @type {(inputs: Mk_Sol_Agensi_P1dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keputusan klien tercecer di grup WhatsApp. Saat revisi ketiga datang, tidak ada yang bisa menunjukkan apa yang disepakati di revisi pertama.`)
};

/**
* | output |
* | --- |
* | "Client decisions scatter across WhatsApp groups. By the third revision nobody can point at what was agreed in the first." |
*
* @param {Mk_Sol_Agensi_P1dInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_agensi_p1d = /** @type {((inputs?: Mk_Sol_Agensi_P1dInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Agensi_P1dInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_agensi_p1d(inputs)
	return en_mk_sol_agensi_p1d(inputs)
});